import Heading from './heading';
import Body from './body';
import Link from './link';
import FooterLink from './footer-link';
import Footer from './footer';
import OptionLabel from './option-label';
import OptionDetail from './option-detail';

export { Heading, Body, Link, FooterLink, Footer, OptionLabel, OptionDetail };
